export function toTooltipConfig(contentOrConfig) {
  return typeof contentOrConfig === 'string'
    ? { content: contentOrConfig }
    : contentOrConfig;
}
